export default {
  props: [
    {
      attr: 'phone',
      name: '手机号'
    },
    {
      attr: 'userId',
      name: '是否注册',
      slot: 'userId'
    },
    {
      attr: 'realname',
      name: '用户姓名',
      slot: 'realname'
    },
    {
      attr: 'age',
      name: '用户年龄'
    },
    {
      attr: 'projects',
      name: '作品',
      slot: 'projects'
    },
    {
      attr: 'status',
      name: '点评状态',
      slot: 'status'
    }
  ]
}
